<template>
  <section class="nav-scroll filters">
    <div class="nav-scroll__wrap filters__wrap">
      <div class="nav-scroll__inner filters__inner">
        <slot />
      </div>
    </div>
  </section>
</template>

<script>
    import initNavScroll from '../javascripts/site/nav-scroll'

    export default {
        name: 'NavScroll',
        mounted() {
            initNavScroll()
        },
    }
</script>

<style scoped>

</style>
